import { motion } from "framer-motion";
import { PlayCircle } from "lucide-react";

const VIDEOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_clean-toronto/artifacts/q9a9c89e_copy_E6BC0DB0-DDFB-419A-BE03-2C8E7D67F807.MOV",
    label: "Deep cleaning in progress",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clean-toronto/artifacts/xsz2fo2q_IMG_8342%20%281%29.MOV",
    label: "Sparkling after-clean walkthrough",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_clean-toronto/artifacts/9gw23vwk_IMG_9020.MOV",
    label: "Final result · spotless finish",
  },
];

export default function VideoShowcase() {
  return (
    <section
      id="showcase"
      data-testid="video-showcase"
      className="pc-section bg-white"
    >
      <div className="pc-container">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="eyebrow text-[var(--pc-green-hover)]">In Action</div>
            <h2 className="font-display mt-3 max-w-2xl text-4xl font-black tracking-tighter sm:text-5xl">
              Real cleans. Real results.
            </h2>
          </div>
          <p className="max-w-md text-base text-black/60">
            Short clips from actual Pristyn jobs — no filters, no staging, just
            the finish.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {VIDEOS.map((v, i) => (
            <motion.div
              key={v.src}
              data-testid={`showcase-video-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative overflow-hidden rounded-3xl border border-black/10 bg-black"
            >
              <video
                className="aspect-[9/16] h-full w-full object-cover"
                src={v.src}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <div className="pointer-events-none absolute left-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-[var(--pc-green)] text-black">
                <PlayCircle size={20} />
              </div>
              <div className="pointer-events-none absolute bottom-4 left-4 right-4 text-sm font-semibold text-white">
                {v.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
